import { render } from "./UpadateOrganization.vue?vue&type=template&id=418253e8&ts=true"
import script from "./UpadateOrganization.vue?vue&type=script&lang=ts"
export * from "./UpadateOrganization.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__